export default {
	title: "Atendimento",
	goToAttendance: "Distribuir Fichas",
	consultant: "Consulente",
	medium: "Médium",
	guide: "Guia",
	startAttendance: "Iniciar Atendimento",
	finishAttendance: "Finalizar Atendimento",
	cancel: "Cancelar",
	notes: "Observações",
	addObservation: "Adicionar Observação",
	observation: "Observação",
	attendanceCard: "Ficha de Atendimento",
	ticketDetails: "Detalhes da Ficha",
	notAssigned: "Não designado",
	confirmStatusChange: "Confirmar Mudança de Status",
	statusChangeConfirmation: "Deseja alterar o status da ficha {code} para {status}?",
	deleteConfirmation: "Deseja realmente excluir a ficha {code}?",
	pendingTickets: "Fichas Pendentes",
	noTicketsFound: "Nenhuma ficha encontrada",
	noTicketsDescription: "Esta pessoa ainda não possui fichas de atendimento",
	statusLabel: "Status",
	status: {
		PENDING: "Aguardando",
		IN_PROGRESS: "Em Atendimento",
		COMPLETED: "Concluído",
		CANCELLED: "Cancelado",
	},
	messages: {
		ticketCreated: "Ficha {code} criada com sucesso",
		ticketUpdated: "Ficha atualizada com sucesso",
		ticketCancelled: "Ficha cancelada",
		ticketDeleted: "Ficha excluída com sucesso",
		statusUpdated: "Status da ficha atualizado",
		loadError: "Erro ao carregar fichas",
		errorFetching: "Erro ao carregar fichas",
		errorUpdating: "Erro ao atualizar ficha",
		observationAdded: "Observação atualizada com sucesso",
	},
	createdAt: "Criada em",
	startedAt: "Iniciada em",
	finishedAt: "Finalizada em",
	cancelledAt: "Cancelada em",
	timeline: {
		today: "Hoje",
		daysSinceLastVisit: "dias sem atendimento",
		startedIn: "Iniciou em",
	},
	table: {
		headers: {
			code: "Código",
			consultant: "Consulente",
			medium: "Médium",
			attendanceCard: "Ficha de Atendimento",
			guide: "Guia",
			status: "Status",
		},
	},
	print: "Imprimir",
	personAttendances: {
		title: "Atendimentos",
		received: "Recebidos",
		given: "Realizados",
		timeline: "Linha do tempo",
		list: "Lista",
	},
	mediumAttendances: {
		title: "Atendimentos Realizados",
		exportPdf: "Exportar PDF",
		pdfError: "Erro ao gerar o PDF de atendimentos",
		empty: "Nenhum atendimento encontrado no período",
		filters: {
			thisYear: "Este ano",
		},
		kpis: {
			attendances: "Atendimentos",
			rituals: "Rituais",
			totalTime: "Tempo total",
			avgTime: "Tempo médio",
		},
		table: {
			date: "Data",
			ritual: "Ritual",
			duration: "Duração",
		},
	},
	validation: {

	},
};
